"use client";

import { Button } from "@/components/ui/button";
import useLocaleRouter from "@/hooks/useLocaleRouter";
import { cn } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { Table } from "@tanstack/react-table";
import { X } from "lucide-react";

export default function FlexBottom<T>({
  table,
  categorySlug,
}: {
  table: Table<T>;
  categorySlug?: string;
}) {
  const t = useScopedI18n("选型器");

  const router = useLocaleRouter();

  const rows = table.getSelectedRowModel()?.rows ?? [];

  return (
    <div
      className={cn(
        "fixed bottom-0 left-0 right-0 z-[999] w-full overflow-y-auto border-t border-[#ddd] bg-[#f7f7f7] px-6 pb-3 pt-4 shadow-[0px_-8px_8px_rgba(0,0,0,0.1)]",
        {
          hidden: rows.length < 2,
        }
      )}>
      <div className="flex items-center space-x-5">
        <Button
          className="px-8 rounded-md"
          disabled={rows.length > 5}
          onClick={() => {
            const rowOriginal = rows.map((row) => row.original) as {
              material_number: string;
            }[];

            const url = `/compares-products?category=${categorySlug}&partList=${rowOriginal
              .map((row) => row.material_number)
              .join(",")}`;

            router.push(url.toString());
          }}>
          {t("比较")}
        </Button>

        <Button
          variant="link"
          className="text-[#007c8c] hover:underline"
          onClick={() => {
            table.setRowSelection({});
          }}>
          {t("清除全部")}
        </Button>

        <div className="flex items-center space-x-2 pr-5">
          {rows.slice(0, 5).map((row: any) => (
            <div
              key={row.id}
              onClick={() => {
                row.getToggleSelectedHandler()(row.id);
              }}
              className="flex items-center space-x-1 rounded-full border border-[#ccc] px-5 py-1 transition-colors duration-300 hover:border-primary">
              <span>{row.original?.["material_number"]}</span>

              <div className="cursor-pointer">
                <X size={16} />
              </div>
            </div>
          ))}
        </div>
      </div>
      {rows.length > 5 && (
        <p className=" pt-1 text-primary">{t("最多可比较5个产品")}</p>
      )}
    </div>
  );
}
